// 已登录但还没同意当前版本协议的用户（协议上线前注册的、或协议更新后）：必须同意才能继续使用。
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { DialogContent, DialogRoot } from "@/components/ui/dialog";
import { ErrLine } from "@/components/ui/states";
import { errorMessage } from "@/lib/api/client";
import { ep, qk } from "@/lib/api/endpoints";
import { useAuth } from "@/lib/auth/session";

export function ConsentDialog() {
  const { me, logout } = useAuth();
  const qc = useQueryClient();
  const accept = useMutation({
    mutationFn: ep.acceptPolicy,
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.me }),
  });
  if (!me?.consent_required) return null;
  return (
    <DialogRoot open onOpenChange={() => {}}>
      <DialogContent
        title="用户协议和隐私政策"
        maxWidth={480}
        closable={false}
        onEscapeKeyDown={(e) => e.preventDefault()}
        footer={
          <>
            <Button variant="ghost" onClick={() => void logout()}>
              退出登录
            </Button>
            <Button variant="default" disabled={accept.isPending} onClick={() => accept.mutate()}>
              {accept.isPending ? "提交中…" : "同意并继续"}
            </Button>
          </>
        }
      >
        <div className="flex flex-col gap-3 body-sm">
          <p className="m-0">
            请阅读
            <Link to="/terms" target="_blank">《用户服务协议》</Link>和
            <Link to="/privacy" target="_blank">《隐私政策》</Link>
            ，同意后继续使用。
          </p>
          {accept.error ? <ErrLine>{errorMessage(accept.error, "提交失败，请稍后重试")}</ErrLine> : null}
        </div>
      </DialogContent>
    </DialogRoot>
  );
}
